import React from "react";

import Layout from "../components/trabajaConNosotrosLayout";

const Page = () => <Layout />;

export default Page;
